import { useMemo } from 'react';

import useOrganization from '~/components/OrganizationContext';
import { isClaimStageOperational } from '~/Utils';

import type {
  ClaimStageConfiguration,
  ClaimStageConfigurationsResponse,
  UseFetchClaimStageConfigurationsReturnType,
} from '../types';

interface UseClaimStageConfigurationsReturnType extends UseFetchClaimStageConfigurationsReturnType {
  /** Claims Stages FF is on and at least one stage is enabled */
  isOperational: boolean;
}

interface PartialUseOrganizationContext {
  claimStageConfigurations: ClaimStageConfiguration[];
  isLoadingClaimStageConfigurations: boolean;
  reloadClaimStageConfigurations: () => Promise<ClaimStageConfigurationsResponse | undefined>;
  isErrorClaimStageConfigurations: boolean;
}

const useClaimStageConfigurations = (): UseClaimStageConfigurationsReturnType => {
  const {
    claimStageConfigurations,
    isLoadingClaimStageConfigurations: isLoading,
    reloadClaimStageConfigurations: reloadData,
    isErrorClaimStageConfigurations: isError,
  } = useOrganization() as PartialUseOrganizationContext;

  const isOperational = useMemo(() => {
    return isClaimStageOperational(claimStageConfigurations);
  }, [claimStageConfigurations]);

  return {
    claimStageConfigurations: claimStageConfigurations || [],
    isOperational,
    isLoading,
    isError,
    reloadData,
  };
};

export default useClaimStageConfigurations;
